<template>
  <div>
    <Tabbar :menuIndex='1' />
    <!-- Tab图片 -->
    <div class="product_banner_warp">
      <img
        v-if="menuIndex==0"
        src="../assets/newimg/banner.png"
        alt=""
        class="product_banner"
      />
      <img
        v-else-if="menuIndex==1"
        src="../assets/newimg/banner2.png"
        alt=""
        class="product_banner"
      />
      <img
        v-else
        src="../assets/newimg/banner3.png"
        alt=""
        class="product_banner"
      />
    </div>

    <div class="el-tabs el-tabs--top">
      <!-- tab导航 -->
      <div class="el-tabs__header is-top">
        <div class="el-tabs__nav-wrap is-top">
          <div class="el-tabs__nav-scroll">
            <div
              role="tablist"
              class="el-tabs__nav is-top"
              style="transform: translateX(0px)"
            >
              <div
                class="el-tabs__active-bar is-top"
                style="width: 490px; transform: translateX(0px)"
              ></div>
              <div
                id="tab-first"
                aria-controls="pane-first"
                role="tab"
                aria-selected="true"
                tabindex="0"
                :class="
                  menuIndex==0
                    ? 'el-tabs__item is-top is-active'
                    : 'el-tabs__item is-top'
                "
                @click="clickIndex(0)"
              >
                文字识别引擎
              </div>
              <div
                id="tab-second"
                aria-controls="pane-second"
                role="tab"
                tabindex="-1"
                :class="
                  menuIndex==1
                    ? 'el-tabs__item is-top is-active'
                    : 'el-tabs__item is-top'
                "
                @click="clickIndex(1)"
              >
                图像视频数据结构化引擎
              </div>
              <div
                id="tab-third"
                aria-controls="pane-third"
                role="tab"
                tabindex="-1"
                :class="
                  menuIndex==2
                    ? 'el-tabs__item is-top is-active'
                    : 'el-tabs__item is-top'
                "
                data-url="?activeName=second"
                @click="clickIndex(2)"
              >
                人脸识别与分析引擎
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- tab内容 -->
      <div class="el-tabs__content">
        <!-- OCR识别引擎栏 -->
        <div
          role="tabpanel"
          id="pane-first"
          aria-labelledby="tab-first"
          class="el-tab-pane"
          v-show="menuIndex==0"
        >
          <ul class="look_bug">
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/文字识别.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">通用文字识别</p>
                  <p class="look_bug_p">
                    基于行业前沿的深度学习技术，提供多种文体类识别服务，支持将图片上的文字内容，智能识别为可编辑的文本，可应用于随手拍扫描、纸质文档电子化、电商广告审核等多种场景，大幅提升信息处理效率。
                  </p>
                </div>
              </div>
            </li>
            <li class="look_bug_item bg_g">
              <div class="look_bug_img">
                <img src="../assets/newimg/银行卡识别.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">卡证信息识别</p>
                  <p class="look_bug_p">
                    基于先进深度学习技术，支持提供身份证识别、银行卡识别、图签识别等多种服务，支持将图片上的文字内容，智能识别为结构化的文本，可应用于用户注册、银行开户、政务办事等多种场景，大幅提升信息处理效率。
                  </p>
                </div>
              </div>
            </li>
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/车牌识别.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">车牌识别</p>
                  <p class="look_bug_p">
                    基于行业前沿的深度学习技术，提供高效车牌识别服务，支持将图片上的文字内容，智能识别为结构化的文本，可应用于车主身份认证、ETC出行、违章识别、停车管理等多种场景，大幅提升信息处理效率。
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 图像视频引擎栏 -->
        <div
          role="tabpanel"
          aria-hidden="true"
          id="pane-second"
          aria-labelledby="tab-second"
          class="el-tab-pane"
          v-show="menuIndex==1"
        >
          <ul class="look_bug">
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/人脸解析分割.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">人脸解析分割</p>
                  <p class="look_bug_p">
                    基于行业前沿的深度学习技术，提供人脸解析分割服务，支持将图片上人脸轮廓与图像背景进行分离，可应用于人像抠图与美化、五官分析、人脸比对、影视后期处理等多种场景，大幅提升信息处理效率。
                  </p>
                </div>
              </div>
            </li>
            <li class="look_bug_item bg_g">
              <div class="look_bug_img">
                <img src="../assets/newimg/火焰检测.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">火焰检测</p>
                  <p class="look_bug_p">
                    基于行业前沿的深度学习技术，提供高性能火焰检测服务，支持图片上火焰信息的识别，可应用于森林火灾、铁路高压线火灾等多种场景告警任务，可大幅提升灾情处理效率。
                  </p>
                </div>
              </div>
            </li>
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/头盔检测.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">安全帽检测</p>
                  <p class="look_bug_p">
                    基于行业前沿的深度学习技术，提供高性能安全帽检测服务，可应用于交通安全行为、工地安全行为等多种场景告警任务，可大幅提升危险处理效率。
                  </p>
                </div>
              </div>
            </li>
            <li class="look_bug_item bg_g">
              <div class="look_bug_img">
                <img src="../assets/newimg/场景分割.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">街道场景分割</p>
                  <p class="look_bug_p">
                    基于先进的深度学习技术，提供街道场景分割服务，支持将图片上街道各类别区域进行分类区别，可应用于无人驾驶或智能辅助驾驶等场景。
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 人体行为分析栏 -->
        <div
          role="tabpanel"
          aria-hidden="true"
          id="pane-third"
          aria-labelledby="tab-third"
          class="el-tab-pane"
          v-show="menuIndex==2"
        >
          <ul class="look_bug">
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/人体姿态.png" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">人体姿态估计</p>
                  <p class="look_bug_p">
                    基于高性能深度学习技术，提供高精度关键点定位服务，支持将图像上的人体信息，智能化为人体骨骼信息，可应用于人群密度检测、体育健身、直播平台娱乐互动、安防监控等多种场景。
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <ul class="look_bug">
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/renlian.jpeg" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">人脸识别</p>
                  <p class="look_bug_p">
                    可以在视频、图像中实现人脸实时检测，可用于相机、直播等多种场景。
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <ul class="look_bug">
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/tezheng.jpeg" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">特征分析</p>
                  <p class="look_bug_p">
                    准确识别出照片中人物的性别、年龄、种族、情绪、颜值、性感、时尚等属性，平均准确率超过90%，
                    年龄预测平均误差小于3岁。
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <ul class="look_bug">
            <li class="look_bug_item bg_w">
              <div class="look_bug_img">
                <img src="../assets/newimg/bidui.jpeg" alt="" />
              </div>
              <div class="look_bug_text">
                <div>
                  <p class="look_bug_title">人脸比对</p>
                  <p class="look_bug_p">
                    基于深度学习的人脸对比技术，实现人脸相似度测量，可用于人脸聚类、敏感人物监控等场景。
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Tabbar from "@/components/Nav/Nav.vue";
import Foot from "@/components/foot/Foot.vue";
import "element-ui/lib/theme-chalk/display.css";
export default {
  components: {
    Tabbar,
    Foot,
  },
  data() {
    return {
      menuIndex:0
    };
  },
  mounted() {
    if (this.$route.query.activeName) {
      this.menuIndex = Number(this.$route.query.activeName);
    }

  },
  methods: {
    clickIndex(index) {
    this.menuIndex = index;
    },
  },
};
</script>

<style scoped>
  #app,
  .content,
  .wrapper,
  body,
  html {
    height: 100%;
  }
  .product_banner {
    /* margin-top: 24px; */
    vertical-align: middle;
    width: 100%;
  }
  .product_warp {
    margin-top: 76px;
  }
  .product_banner_warp {
    overflow: hidden;
    /* margin-bottom: -70px; */
  }
  .look_bug_item {
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 50px 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .look_bug_img {
    width: 38%;
    text-align: center;
    min-width: 460px;
  }
  .look_bug_img img,
  .look_bug_img video {
    width: 90%;
    vertical-align: middle;
  }
  .look_bug_title {
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .look_bug_p {
    line-height: 30px;
    font-size: 15px;
    text-align: left;
  }
  .look_bug_text {
    width: 22%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    min-width: 264px;
  }
  .bg_g {
    background-color: #fff;
    background-color: #f7f7f7;
  }
  .el-tabs__item.is-active {
    background: #008cee;
    color: #fff;
    opacity: 1;
  }
  .el-tabs__item {
    height: 70px;
    line-height: 70px;
    width: 33.333%;
    text-align: center;
    background: #0b0b0b;
    opacity: 0.64;
    color: #fff;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__nav {
    width: 100%;
  }


.el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
}
.el-tabs__nav {
  white-space: nowrap;
  position: relative;
  transition: transform 0.3s;
  float: left;
  z-index: 2;
}
</style>
